var _defs, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvoices2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 372.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:#ebebeb;}.cls-2{fill:#fafafa;}.cls-15,.cls-16,.cls-17,.cls-3{fill:#fff;}.cls-4{fill:#e0e0e0;}.cls-5{fill:#f0f0f0;}.cls-16,.cls-6{opacity:0.5;}.cls-7{fill:#e6e6e6;}.cls-8{fill:#f5f5f5;}.cls-9{fill:#ff8b7b;}.cls-10{fill:#407bff;}.cls-11{opacity:0.2;}.cls-12{fill:#263238;}.cls-13{fill:#ff5652;}.cls-14{opacity:0.3;}.cls-15{opacity:0.7;}.cls-17{opacity:0.8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 327.45,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 423.9,
    y: 343.54,
    width: 26,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 311,
    y: 346.26,
    width: 45.03,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 362.11,
    y: 334.26,
    width: 60.79,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.46,
    y: 335.94,
    width: 19.23,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 80.6,
    y: 335.94,
    width: 55.29,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 169.67,
    y: 340.16,
    width: 74.47,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 77.5,
    y: 30.44,
    width: 200.95,
    height: 144.26
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "131.38 174.7 165.84 30.44 204.2 30.44 169.74 174.7 131.38 174.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "206.3 174.7 240.76 30.44 254.75 30.44 220.29 174.7 206.3 174.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "118.14 174.7 152.61 30.44 157.86 30.44 123.4 174.7 118.14 174.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M288,80.43H67.92a.9.9,0,0,0-.9.9h0a.89.89,0,0,0,.9.89H288a.9.9,0,0,0,.9-.89h0A.91.91,0,0,0,288,80.43Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 174.58,
    y: 85.08,
    width: 8.57,
    height: 144.88,
    transform: "translate(357.73 260.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 183.15,
    y: 85.08,
    width: 0.96,
    height: 144.88,
    transform: "translate(367.26 260.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 176.78,
    y: 55.66,
    width: 2.38,
    height: 203.73,
    transform: "translate(20.45 280.55) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M279.84,228.66h0V84H76.11V228.66h0V231H279.84Zm-201.35,0V86.39h199V228.66Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 279.84,
    y: 84.01,
    width: 1.19,
    height: 147.04,
    transform: "translate(560.87 260.1) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "244.39 23.3 244.39 262.9 294.62 262.9 285.41 23.3 244.39 23.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "209.53 23.3 209.53 262.9 259.76 262.9 250.55 23.3 209.53 23.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "93.42 23.3 93.42 262.9 62.52 262.9 68.19 23.3 93.42 23.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "114.87 23.3 114.87 262.9 83.97 262.9 89.63 23.3 114.87 23.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 188.18,
    y: 230.14,
    width: 22.17,
    height: 152.26,
    transform: "translate(398.53 557.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "195.99 327.44 188.18 327.44 188.18 298.51 204.17 298.51 195.99 327.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 422.67,
    y: 230.14,
    width: 22.17,
    height: 152.26,
    transform: "translate(867.51 557.58) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 188.18,
    y: 230.14,
    width: 241.3,
    height: 144.36,
    transform: "translate(617.66 549.68) rotate(180)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "421.67 327.44 429.48 327.44 429.48 298.51 413.49 298.51 421.67 327.44"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 325.98,
    y: 266.04,
    width: 119.42,
    height: 71.53,
    transform: "translate(83.89 632.54) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M378.62,246.29h14.15A24,24,0,0,0,409,240.18H362.37A24,24,0,0,0,378.62,246.29Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 249.12,
    y: 266.04,
    width: 119.42,
    height: 71.53,
    transform: "translate(7.03 555.68) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M301,246.29h14.15a24,24,0,0,0,16.25-6.11H284.78A24,24,0,0,0,301,246.29Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 172.26,
    y: 266.04,
    width: 119.42,
    height: 71.53,
    transform: "translate(-69.83 478.82) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M224.17,246.29h14.15a24,24,0,0,0,16.25-6.11H207.92A24,24,0,0,0,224.17,246.29Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M436,202.51H362.51s.67,18.94,21.74,25.19v2.44h30V227.7C435.35,221.45,436,202.51,436,202.51Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 319.96,
    y: 27.48,
    width: 96.13,
    height: 102.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 416.09,
    y: 82.44,
    width: 3.18,
    height: 102.94,
    transform: "translate(835.37 212.86) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 336.22,
    y: 36.31,
    width: 63.62,
    height: 85.28
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-8",
    cx: 250,
    cy: 361.29,
    rx: 193.89,
    ry: 11.32
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "367.85 357.38 359.71 357.25 359.16 338.36 367.3 338.48 367.85 357.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M359.43,406.82l8.89.14a.68.68,0,0,1,.66.57l1.18,7.26a1.24,1.24,0,0,1-1.25,1.43c-3.21-.1-7.83-.36-11.86-.43-4.71-.07-1,.12-6.52,0-3.34-.06-4.07-3.45-2.65-3.73,6.44-1.3,6.77-2.74,9.56-4.67A3.39,3.39,0,0,1,359.43,406.82Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M336.36,168.16c-.7,2.76-1.51,5.27-2.35,7.88s-1.78,5.13-2.76,7.68a109.91,109.91,0,0,1-7.13,15c-.34.62-.73,1.22-1.11,1.83l-.58.91-.28.46c-.09.14-.26.36-.38.54a19.35,19.35,0,0,1-3.66,3.92,26.7,26.7,0,0,1-8.46,4.52,39.55,39.55,0,0,1-8.58,1.8c-1.42.16-2.84.22-4.25.24a39.69,39.69,0,0,1-4.31-.17l-.16-6.12A55.3,55.3,0,0,0,306,202a19.82,19.82,0,0,0,5-3.62,10,10,0,0,0,1.48-2l.16-.28.21-.4.42-.8c.27-.53.56-1,.81-1.61a134.24,134.24,0,0,0,5.67-13.88c.86-2.39,1.65-4.81,2.46-7.23s1.54-4.92,2.25-7.23Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M294.28,206.7l-9.24-1,.44,9.28s7,1.7,9.92-3.64Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M277.43,209.81l1.71,4a1.84,1.84,0,0,0,1.65,1.11l4.69.11-.44-9.28-6.29,1.49A1.91,1.91,0,0,0,277.43,209.81Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "359.16 338.36 359.44 348.1 367.58 348.23 367.3 338.49 359.16 338.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328.1,157.84c-4.37,5.49-8.35,16-10,22,4.85,8.07,14.35,6.66,14.35,6.66s7.86-6.22,10.43-13.66S335.82,148.13,328.1,157.84Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.58,159c1.93,14.06-1,32.35,1.22,59l-43.54,2.76c-7.92-33.81-8.77-48-9.61-57.33a8.54,8.54,0,0,1,5.27-8.65c10.26-4.25,27.86-4.88,39.95-2.75A8.19,8.19,0,0,1,378.58,159Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M346.81,168.35a11.17,11.17,0,0,0-9.56,5.28h20.22A14.16,14.16,0,0,0,346.81,168.35Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.08,174.39H336.8a13.11,13.11,0,0,0-1.15,3h24.19A16.2,16.2,0,0,0,358.08,174.39Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M360.28,178.35H335.43a14.84,14.84,0,0,0-.22,2.7h25.86A17.16,17.16,0,0,0,360.28,178.35Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.25,195.9h8.88a10.92,10.92,0,0,0,2.85-1.73H342A14.25,14.25,0,0,0,345.25,195.9Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.76,192.19h19.09a12.58,12.58,0,0,0,1.19-2H338.15A17.06,17.06,0,0,0,339.76,192.19Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M337.09,188.47h23.64a13.16,13.16,0,0,0,.5-2.21h-25.1A16.76,16.76,0,0,0,337.09,188.47Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.27,182.3h-26a2.11,2.11,0,0,0,0,.25,16.21,16.21,0,0,0,.39,2.21h25.69a15,15,0,0,0-.08-2.21A2.11,2.11,0,0,0,361.27,182.3Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M357.67,131.14l-11.76,10.38c1.69,4.41,2.37,9.16-4.33,11.26a1.53,1.53,0,0,0-.87.69c-1.58,2.74-1.91,7,5.47,6.34a22.45,22.45,0,0,0,14.45-7,1.44,1.44,0,0,0,.1-2C356.73,146.51,357,136.7,357.67,131.14Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M352.87,135.37l-7,6.15a17.11,17.11,0,0,1,1,3.22c2.8-.53,6.42-3.53,6.47-6.18A8.07,8.07,0,0,0,352.87,135.37Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M335.63,116.61c-2.58,3.56-.88,11.81,1,13.11C341.43,127.47,340.55,114.58,335.63,116.61Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M357.88,122.06c0,8.07.34,12.79-3.5,17.19-5.77,6.61-15.94,3.58-18.32-4.32-2.14-7.11-1.71-19.11,6-22.83A10.93,10.93,0,0,1,357.88,122.06Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M357.34,130.05c1.18-2.7-5.2-1.09-5.2-1.09s-1-8.64,1.74-12c-2.77,1.65-10.11,1.6-11.63,0-3.09,1.56-7.19,2-9.81.21s-2.49-6.05-.8-8.08c2.15,2,5.2-.76,3.84-2.11,4.3-2.58,11.59-1.18,13,.3a2.38,2.38,0,0,1,.72-3.26s.85,3.27,3.43,3.13c4.56-.25,9.9,1.31,7.86,5.62,3.26.34,4.82,4.06,3.85,7s1.95,3.47,2.28,2.58c1.1,2.07.22,3.3-1.69,4.06,5,5.78-5.66,7.54-7.64,11.3C357.27,137.67,355.91,133.34,357.34,130.05Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.14,129.68a7.8,7.8,0,0,1-4.33,4c-2.54.93-4-1.28-3.45-3.77.49-2.25,2.41-5.44,5-5.29S363.18,127.41,362.14,129.68Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M367.8,307.34c-2.62-41,2.47-88.79,2.47-88.79l-34,2.16c2,15.45,8,65.14,10.47,89.43,2.63,25.79,9.71,88.59,9.71,88.59l13.8.21S371.52,339.66,367.8,307.34Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M367.55,302.91c0-.54-.05-1.07-.08-1.61-.84-18.46-.28-37.75.55-53.05l-2.1,1.33c-8.94,13.25-3.2,38.18,1.75,55.8C367.63,304.56,367.58,303.73,367.55,302.91Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "355.15 340.95 356.25 346.57 370.58 346.82 371.14 341.52 355.15 340.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346.26,125.36c0,.65-.28,1.21-.71,1.24s-.81-.48-.85-1.14.28-1.21.71-1.24S346.22,124.7,346.26,125.36Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M337.2,126.08c0,.65-.28,1.21-.71,1.23s-.81-.48-.85-1.13.28-1.21.71-1.24S337.16,125.42,337.2,126.08Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M340.73,125.77a23.69,23.69,0,0,1-2.83,5.81,3.81,3.81,0,0,0,3.17.38Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M343.94,133.53a5.51,5.51,0,0,0,3.59-2.39.21.21,0,0,0-.07-.27.19.19,0,0,0-.26.08,5.33,5.33,0,0,1-4.13,2.3.19.19,0,0,0-.18.21.18.18,0,0,0,.2.18A7.29,7.29,0,0,0,343.94,133.53Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M348.33,121.33a.32.32,0,0,0,.17-.09.37.37,0,0,0,.05-.54,3.81,3.81,0,0,0-3.23-1.38.4.4,0,0,0-.34.43.38.38,0,0,0,.43.33h0A3.05,3.05,0,0,1,348,121.2.37.37,0,0,0,348.33,121.33Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M335,122.73a.41.41,0,0,0,.31-.2,3.11,3.11,0,0,1,2.27-1.64.39.39,0,1,0-.05-.77,3.92,3.92,0,0,0-2.9,2,.39.39,0,0,0,.15.52A.44.44,0,0,0,335,122.73Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "412.84 357.97 404.68 357.84 400.87 338.95 409.02 339.08 412.84 357.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M411.65,407l-8.87-.08a.45.45,0,0,0-.49.55l1.09,7.27a1.86,1.86,0,0,0,1.7,1.47c3.18,0,4.13-.26,8.15-.22,4.7,0,2.57.18,8.08.23,3.34,0,3-3.34,1.5-3.68-4.78-1.06-6.43-2.9-9-4.88A3.6,3.6,0,0,0,411.65,407Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "400.87 338.95 402.83 348.69 410.99 348.82 409.03 339.08 400.87 338.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M396.28,306.74c-5.68-37.07-10.61-74.15-16.46-88.79L351,219.77s16.21,63.52,24.49,89.23c4,27,23.89,90.41,23.89,90.41l12.94-.57S402,343.81,396.28,306.74Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "397.36 342.18 399.4 347.7 413.74 347.24 413.41 341.94 397.36 342.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.31,161.86c.46.73.8,1.3,1.18,1.94s.69,1.24,1,1.87c.66,1.25,1.29,2.51,1.91,3.77a82.72,82.72,0,0,1,3.23,7.84,68.88,68.88,0,0,1,2.4,8.23l.46,2.12.37,2.16c.13.71.2,1.45.28,2.18l.12,1.1.06.55,0,.13,0,.42a8.19,8.19,0,0,1-.59,3.51,11.06,11.06,0,0,1-.89,1.76,15.25,15.25,0,0,1-1.82,2.33,31.31,31.31,0,0,1-3.55,3.17,66.56,66.56,0,0,1-7.11,4.7,109.07,109.07,0,0,1-14.74,7.1l-2.9-5.38c4.18-3.09,8.46-6.19,12.43-9.38,2-1.58,3.92-3.22,5.6-4.85a19.91,19.91,0,0,0,2.13-2.37,6.09,6.09,0,0,0,.53-.87c.07-.14-.09-.19-.2.69,0,.08,0,.23,0,.36v.17l0-.11-.09-.43-.18-.87c-.11-.58-.22-1.16-.38-1.74l-.44-1.73-.51-1.74c-.71-2.31-1.52-4.61-2.45-6.89s-1.94-4.55-3-6.78c-.54-1.11-1.09-2.23-1.67-3.31l-.88-1.62-.83-1.5Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.69,210.2l-8.22.84L358,220.2s7.36-1.66,7.19-5.7Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M348.89,217.63l1.79,3a2.8,2.8,0,0,0,3.49,1.14L358,220.2,354.47,211,350,213.67A2.89,2.89,0,0,0,348.89,217.63Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M357.48,166.24c2.39,6.49,10.89,15,15.17,19.42,9.5-.12,15.86-9.49,15.86-9.49s-4.32-16.44-12.76-22.38C369.4,149.33,353.27,154.76,357.48,166.24Z",
    transform: "translate(0 -54.95)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Printer"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 142.76,
    y: 247.57,
    width: 197.24,
    height: 18.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 284.01,
    y: 247.57,
    width: 55.99,
    height: 18.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 142.76,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "154.56 271.02 142.76 268.46 142.76 265.89 154.56 265.89 154.56 271.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 328.2,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 328.2,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 284.01,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "295.82 271.02 284.01 268.46 284.01 265.89 295.82 265.89 295.82 271.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 179.72,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 179.72,
    y: 265.89,
    width: 11.81,
    height: 98.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "319.96 155.57 172.09 155.57 158.96 213.07 306.83 213.07 319.96 155.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.96 155.57 323.34 155.57 310.21 213.07 306.83 213.07 319.96 155.57"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 116.07,
    y: 178.57,
    width: 237.13,
    height: 69,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 301.96,
    y: 178.57,
    width: 51.25,
    height: 69,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M293.2,251.35H124.83a2,2,0,0,1-2-2h0a2,2,0,0,1,2-2H293.2a2,2,0,0,1,2,2h0A2,2,0,0,1,293.2,251.35Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.4,269.85h10.12a1.67,1.67,0,0,0,1.66-1.66h0a1.67,1.67,0,0,0-1.66-1.67H283.4a1.67,1.67,0,0,0-1.66,1.67h0A1.67,1.67,0,0,0,283.4,269.85Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.4,276.94h10.12a1.67,1.67,0,0,0,1.66-1.67h0a1.67,1.67,0,0,0-1.66-1.66H283.4a1.67,1.67,0,0,0-1.66,1.66h0A1.67,1.67,0,0,0,283.4,276.94Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.4,284h10.12a1.67,1.67,0,0,0,1.66-1.67h0a1.67,1.67,0,0,0-1.66-1.67H283.4a1.67,1.67,0,0,0-1.66,1.67h0A1.67,1.67,0,0,0,283.4,284Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.11,249.35c1.95-16.87-10.15-30.54-27-30.54H260.3c16.87,0,29,13.67,27,30.54Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M164.11,249.35c1.95-16.87-10.15-30.54-27-30.54H260.3c16.87,0,29,13.67,27,30.54Z",
    transform: "translate(0 -54.95)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M137.09,218.81H260.3c-16.86,0-32.11,13.67-34.06,30.54l-14,121.33c-1.94,16.87-17.19,30.54-34.06,30.54H116.08c-16.87,0-29-13.67-27-30.54l14-121.33C105,232.48,120.22,218.81,137.09,218.81Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M137.09,218.81H260.3c-16.86,0-32.11,13.67-34.06,30.54l-14,121.33c-1.94,16.87-17.19,30.54-34.06,30.54H116.08c-16.87,0-29-13.67-27-30.54l14-121.33C105,232.48,120.22,218.81,137.09,218.81Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M151.19,370.68c-1.95,16.87,10.15,30.54,27,30.54H55c-16.87,0-29-13.67-27-30.54Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M151.19,370.68c-1.95,16.87,10.15,30.54,27,30.54H55c-16.87,0-29-13.67-27-30.54Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M112,259.9h2.9l-1.08,9.36h-2.9Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M117,259.9h2.7l2.93,5.18.59-5.18h2.73l-1.08,9.36h-2.72l-2.92-5.14-.59,5.14h-2.72Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M126.91,259.9h3l1.33,6.74,2.85-6.74h2.94l-4.56,9.36h-3.13Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.65,264.59a5.44,5.44,0,0,1,1.69-3.57,5.34,5.34,0,0,1,3.7-1.28A4.4,4.4,0,0,1,145.5,261a4.34,4.34,0,0,1,.86,3.51,6.28,6.28,0,0,1-.87,2.69,4.61,4.61,0,0,1-1.78,1.64,6.61,6.61,0,0,1-5.23.08,3.39,3.39,0,0,1-1.5-1.6A5.1,5.1,0,0,1,136.65,264.59Zm2.89,0a2.94,2.94,0,0,0,.29,2,1.61,1.61,0,0,0,1.37.62,2,2,0,0,0,1.51-.61,3.77,3.77,0,0,0,.76-2.18,2.69,2.69,0,0,0-.31-1.93,1.64,1.64,0,0,0-1.38-.61,2,2,0,0,0-1.47.62A3.52,3.52,0,0,0,139.54,264.6Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M148.56,259.9h2.9l-1.08,9.36h-2.9Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M159.13,265.43l2.44.77a5.38,5.38,0,0,1-1,1.78,4,4,0,0,1-1.48,1.08,5.49,5.49,0,0,1-2.12.36,5.76,5.76,0,0,1-2.44-.44,3.38,3.38,0,0,1-1.49-1.56,5,5,0,0,1-.37-2.86,5.46,5.46,0,0,1,1.65-3.57,5.2,5.2,0,0,1,3.63-1.25,4.34,4.34,0,0,1,2.7.72,3.61,3.61,0,0,1,1.25,2.2l-2.62.56a1.64,1.64,0,0,0-.21-.62,1.37,1.37,0,0,0-.53-.51,1.59,1.59,0,0,0-.77-.18,1.92,1.92,0,0,0-1.59.79,3.67,3.67,0,0,0-.61,1.84,3.28,3.28,0,0,0,.23,2.13,1.42,1.42,0,0,0,1.26.58,1.81,1.81,0,0,0,1.31-.46A3.5,3.5,0,0,0,159.13,265.43Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.7,259.9h7.75l-.23,2h-4.86l-.17,1.49h4.5l-.22,1.91H166l-.21,1.84h5l-.24,2.12h-7.89Z",
    transform: "translate(0 -54.95)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "211.76 238.73 107.3 238.73 108.66 226.9 213.12 226.9 211.76 238.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "211.76 238.73 107.3 238.73 106.19 248.4 210.65 248.4 211.76 238.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "204.54 301.42 172.75 301.42 173.4 295.7 205.2 295.7 204.54 301.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "204.54 301.42 172.75 301.42 172.21 306.09 204 306.09 204.54 301.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "209.53 258.07 105.07 258.07 106.19 248.4 210.65 248.4 209.53 258.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "209.53 258.07 105.07 258.07 103.96 267.73 208.42 267.73 209.53 258.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "207.31 277.4 102.84 277.4 103.96 267.73 208.42 267.73 207.31 277.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "207.31 277.4 102.84 277.4 101.73 287.07 206.19 287.07 207.31 277.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices2);
export default __webpack_public_path__ + "static/media/invoices2.fc464b89e3574c9f4b70e13970762322.svg";
export { ForwardRef as ReactComponent };